import { useToastError } from "@/components/ui/use-toast";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApi } from "./useApi";

export const useIntegrationDialogs = () => {
  const api = useApi();
  const toastError = useToastError();

  const { t } = useTranslation();

  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [openEarlyAccessDialog, setOpenEarlyAccessDialog] = useState(false);
  const [requestValue, setRequestValue] = useState("");
  const [earlyAccessValue, setEarlyAccessValue] = useState("");
  const [integrationName, setIntegrationName] = useState<string>("");
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingEarlyAccess, setLoadingEarlyAccess] = useState(false);
  const [successRequest, setSuccessRequest] = useState(false);
  const [successEarlyAccess, setSuccessEarlyAccess] = useState(false);

  const handleRequestSubmit = async () => {
    if (!requestValue.trim()) return;
    setLoadingRequest(true);
    try {
      await api.post("/my/team/integration/request", {
        type: "INTEGRATION_REQUEST",
        message: requestValue.trim(),
      });
      setSuccessRequest(true);
    } catch (e) {
      toastError();
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleEarlyAccessSubmit = async () => {
    if (!earlyAccessValue.trim()) return;
    setLoadingEarlyAccess(true);
    try {
      await api.post("/my/team/integration/request", {
        type: "INTEGRATION_EARLY_ACCESS",
        message: earlyAccessValue.trim(),
        integrationName: integrationName,
      });
      setSuccessEarlyAccess(true);
    } catch (e) {
      toastError();
    } finally {
      setLoadingEarlyAccess(false);
    }
  };

  const openEarlyAccess = (name: string) => {
    setIntegrationName(name);
    setEarlyAccessValue(
      t("team.integrations.earlyAccess.defaultMessage", { name }),
    );
    setOpenEarlyAccessDialog(true);
  };

  const closeEarlyAccessDialog = () => {
    setOpenEarlyAccessDialog(false);
    setIntegrationName("");
    setEarlyAccessValue("");
    setSuccessEarlyAccess(false);
  };

  return {
    // Request dialog state
    openRequestDialog,
    setOpenRequestDialog,
    requestValue,
    setRequestValue,
    loadingRequest,
    successRequest,
    handleRequestSubmit,

    // Early access dialog state
    openEarlyAccessDialog,
    setOpenEarlyAccessDialog,
    earlyAccessValue,
    setEarlyAccessValue,
    loadingEarlyAccess,
    successEarlyAccess,
    handleEarlyAccessSubmit,
    openEarlyAccess,
    closeEarlyAccessDialog,
  };
};
